import dynamic from 'next/dynamic'

export const Elevio = dynamic(() => import('elevio/lib/react'), {
  ssr: false,
})
